export default __webpack_public_path__ + "static/media/icon-form-success.591b2cf9.svg";